import { useContext } from "react";

import { EmployeeContext, EmployeeContextType } from "../Contexts/EmployeeContext";

function useEmployeeContext(): EmployeeContextType {
    const context = useContext<EmployeeContextType | undefined>(EmployeeContext);

    if (context === undefined) {
        throw new Error("useEmployeeContext must be used within a EmployeeContextProvider");
    }

    return context;
}

export default useEmployeeContext;
